import { topicsItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热门话题</h2>
          <p className="text-foreground-500 text-sm mt-2">全网最热的网红圈话题都在这里</p>
        </div>

        <div className="max-w-[900px] mx-auto flex flex-wrap justify-center gap-3">
          {topicsItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm transition-all cursor-pointer no-underline ${
                item.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              <span className="whitespace-nowrap">{item.name}</span>
              <span className={`text-xs whitespace-nowrap ${item.hot ? 'text-primary-500' : 'text-foreground-400'}`}>{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}